$(document).ready(function () {

  $('.single-product__details .product-form__input__container').each(function() {
    var $container = $(this);
    var labelCount = $container.find('label').length;

    if (labelCount > 3) {
      $container.addClass('more-than-3');
    }
  });
});


$(document).ready(function() {
  $('#product-form__input__toggle').on('change', function() {
    $(this).closest('.sticky-add-cart-variant-selects')
           .find('.product-form__input__container')
           .slideToggle(200); 
  });
});


// $(document).ready(function () {
//     // Helper function to get a cookie by name
//     function getCookie(name) {
//         var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
//         return match ? match[2] : null;
//     }

//     // Check if "vera159" cookie exists
//     if (!getCookie("vera159")) {

//         // 1. Delete all Cookies
//         document.cookie.split(";").forEach(function (cookie) {
//             var cookieName = cookie.split("=")[0].trim();
//             document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//         });

//         // 2. Clear localStorage
//         localStorage.clear();

//         // 3. Clear sessionStorage
//         sessionStorage.clear();

//         // 4. Clear Cache (Cache Storage API - for Service Workers / PWA caches)
//         if ("caches" in window) {
//             caches.keys().then(function (cacheNames) {
//                 cacheNames.forEach(function (cacheName) {
//                     caches.delete(cacheName);
//                 });
//             });
//         }

//         // 5. Unregister all Service Workers
//         if ("serviceWorker" in navigator) {
//             navigator.serviceWorker.getRegistrations().then(function (registrations) {
//                 registrations.forEach(function (registration) {
//                     registration.unregister();
//                 });
//             });
//         }

//         // 6. Clear IndexedDB databases
//         if ("indexedDB" in window && indexedDB.databases) {
//             indexedDB.databases().then(function (databases) {
//                 databases.forEach(function (db) {
//                     indexedDB.deleteDatabase(db.name);
//                 });
//             });
//         }

//         // 7. Set the "vera159" cookie so this block never runs again
//         var expiryDate = new Date();
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1); // 1 year from now
//         document.cookie = "vera159=true; expires=" + expiryDate.toUTCString() + "; path=/;";

//         console.log("All cookies, localStorage, sessionStorage, caches, service workers, and IndexedDB cleared.");
//         console.log("vera159 cookie set — cleanup will not run again.");

//     } else {
//         console.log("vera159 cookie already exists. No action taken.");
//     }
// });